
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'StrengthGrading',
components: {
XTable
},
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Neuro/StrengthGrading.vue